import { darken } from 'polished';
import styled, { css } from 'styled-components';

import { IButtonProps } from './types';

const defaultProps = (props: IButtonProps): any => {
  const {
    buttonTheme: { background, front, borderRadius, borderColor },
    fontSize,
    iconPosition,
    isIconOnly,
    isSmall,
    disabledUppercase,
  } = props;

  return css`
    align-items: center;
    justify-content: center;

    background: ${background};

    color: ${front};
    font-size: ${fontSize || 1}rem;
    font-weight: bold;

    height: 3.125rem;
    padding: 0 1.5rem;
    border-width: 0;

    border-radius: ${borderRadius || '15px'};
    font-weight: 600;
    cursor: pointer;
    transition: 0.3s;

    ${!disabledUppercase &&
    css`
      text-transform: uppercase;
    `}

    ${borderColor &&
    css`
      border: 2px solid ${borderColor};
    `};

    &:hover {
      background: ${darken(0.05, background)};

      a {
        text-decoration: none;
      }
    }

    &:disabled {
      opacity: 0.5;
      cursor: default;
    }

    svg {
      width: 0.9rem;
      height: 0.9rem;

      margin: ${isIconOnly ? '0' : iconPosition === 'left' ? '0 0.6rem 0 0' : '0 0 0 0.6rem'};
      color: ${front};
    }

    ${isSmall &&
    css`
      height: 2.25rem;
      padding: 0.3rem 1.2rem;
      font-size: 0.8rem;
      border-width: 1px;
      line-height: 18px;
    `}
  `;
};

export const ButtonContainer = styled.button<IButtonProps>`
  ${({ isIconOnly, iconPosition, buttonTheme, isSmall, disabledUppercase }) =>
    defaultProps({ isIconOnly, iconPosition, buttonTheme, isSmall, disabledUppercase })}
`;

export const AContainer = styled.a<IButtonProps>`
  ${({ isIconOnly, iconPosition, buttonTheme, isSmall, disabledUppercase }) =>
    defaultProps({ isIconOnly, iconPosition, buttonTheme, isSmall, disabledUppercase })}

  text-decoration: none;

  &:hover {
    text-decoration: none;
  }
`;

export const LinkContainer = styled.div<IButtonProps>`
  a {
    ${({ isIconOnly, iconPosition, buttonTheme, isSmall, disabledUppercase }) =>
      defaultProps({
        isIconOnly,
        iconPosition,
        buttonTheme,
        isSmall,
        disabledUppercase,
      })}

    text-decoration: none;

    &:hover {
      text-decoration: none;
    }
  }
`;
